import { render } from "./UserLabel.vue?vue&type=template&id=5c19a2ce&ts=true"
import script from "./UserLabel.vue?vue&type=script&lang=ts"
export * from "./UserLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__